export default __webpack_public_path__ + "static/media/logo-sm.e93f48c3.svg";